import type {PhoneNumberSet} from 'src/types/chat/phone-number-sets';
import type {SenseAction} from 'src/action-creators/types';

import {
  RECEIVE,
  RECEIVE_AUTO_REPLY,
  UPDATE_MSG_CHANNEL_TYPE,
  REMOVE_PHONE_NUMBER,
  RECEIVE_AUTO_REPLY_SETTINGS_UPDATES,
} from 'src/action-creators/chat/phone-number-sets';

import omit from 'lodash/omit';


export type State = {
  [phoneNumberSetId: string]: PhoneNumberSet;
};

const initialState = Object.freeze({});

const processData = (data = []) => {
  const obj: Record<string, any> = {};
  data.forEach((phoneNumberSet) => {
    // @ts-expect-error - TS2322 - Type '"sms" | "whatsapp"' is not assignable to type 'never'. | TS2339 - Property 'sms' does not exist on type 'never'.
    phoneNumberSet['default_channel'] = phoneNumberSet.sms ? 'sms' : 'whatsapp';
    phoneNumberSet['selected_channel'] = phoneNumberSet['selected_channel']
      ? phoneNumberSet['selected_channel']
      : phoneNumberSet['default_channel'];
    // @ts-expect-error - TS2339 - Property 'phone_numbers' does not exist on type 'never'.
    if (!Object.keys(obj).includes(phoneNumberSet.phone_numbers[0])) {
      // @ts-expect-error - TS2339 - Property 'phone_numbers' does not exist on type 'never'.
      obj[phoneNumberSet.phone_numbers[0]] = phoneNumberSet;
    }
  });
  return obj;
};

const getPhoneNumberFromPhoneNumberSets = (
  phoneNumberSets: State,
  phoneNumberSetId: string,
) => {
  let phoneNumber: string = '';
  Object.entries(phoneNumberSets).forEach((phoneNumberSet: any) => {
    if (
      phoneNumberSet[1]['sms'] &&
      phoneNumberSet[1].sms.id === phoneNumberSetId
    ) {
      phoneNumber = phoneNumberSet[1].phone_numbers[0];
    }
    if (
      phoneNumberSet[1]['whatsapp'] &&
      phoneNumberSet[1].whatsapp.id === phoneNumberSetId
    ) {
      phoneNumber = phoneNumberSet[1].phone_numbers[0];
    }
  });
  return phoneNumber;
};
export default function reduce(
  state: State | null | undefined = initialState,
  action: SenseAction,
): State {
  switch (action.type) {
    case RECEIVE: {
      return {
        ...state,
        // @ts-expect-error - TS2345 - Argument of type 'PhoneNumberSet[]' is not assignable to parameter of type 'never[]'.
        ...processData(action.payload),
      };
    }
    case RECEIVE_AUTO_REPLY: {
      const phoneNumber = getPhoneNumberFromPhoneNumberSets(
        // @ts-expect-error - TS2345 - Argument of type 'State | null' is not assignable to parameter of type 'State'.
        state,
        action.payload.phoneNumberSetId,
      );
      // @ts-expect-error - TS18047 - 'state' is possibly 'null'. | TS18047 - 'state' is possibly 'null'.
      if (state[phoneNumber].sms && state[phoneNumber].whatsapp) {
        if (
          // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
          action.payload.phoneNumberSetId === state[phoneNumber].whatsapp.id
        ) {
          return {
            ...state,
            [phoneNumber]: {
              // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
              ...state[phoneNumber],
              autoreply: action.payload,
            },
          };
        }
      } else {
        return {
          ...state,
          [phoneNumber]: {
            // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
            ...state[phoneNumber],
            autoreply: action.payload,
          },
        };
      }
      // @ts-expect-error - TS2322 - Type 'State | null' is not assignable to type 'State'.
      return state;
    }
    case RECEIVE_AUTO_REPLY_SETTINGS_UPDATES: {
      const phoneNumber = action.payload.phoneNumber;

      // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
      if (phoneNumber && state[phoneNumber]) {
        return {
          ...state,
          [phoneNumber]: {
            // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
            ...state[phoneNumber],
            autoreply: {
              // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
              ...state[phoneNumber].autoreply,
              ...action.payload.autoReply,
            },
          },
        };
      }
      // @ts-expect-error - TS2322 - Type 'State | null' is not assignable to type 'State'.
      return state;
    }
    case UPDATE_MSG_CHANNEL_TYPE: {
      const phoneNumberSetId = action.payload.phoneNumberSetId;
      // @ts-expect-error - TS2769 - No overload matches this call.
      const phoneNumberSetFound = Object.keys(state).indexOf(phoneNumberSetId);
      if (phoneNumberSetFound === -1) {
        // @ts-expect-error - TS2322 - Type 'State | null' is not assignable to type 'State'.
        return state;
      }
      return {
        ...state,
        [action.payload.phoneNumberSetId]: {
          // @ts-expect-error - TS18047 - 'state' is possibly 'null'. | TS2339 - Property 'payload' does not exist on type 'never'.
          ...state[action.payload.phoneNumberSetId],
          selected_channel: action.payload.selected_channel,
        },
      };
    }
    case REMOVE_PHONE_NUMBER: {
      return {
        ...omit(state, action.payload.phoneNumberSetId),
      };
    }
  }

  // @ts-expect-error - TS2322 - Type 'State | null' is not assignable to type 'State'.
  return state;
}
